module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-event-d132ba32.svg";